// extracted by mini-css-extract-plugin
module.exports = {"scroller":"Scroller_scroller"};